// ไฟล์: frontend/src/pages/ArticlesPage.js
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "./ArticlesPage.css";

const ArticlesPage = () => {
  const [articles, setArticles] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
  const [sortBy, setSortBy] = useState("newest");

  useEffect(() => {
    const fetchData = async () => {
      try {
        // ดึงข้อมูลบทความ
        const articlesResponse = await axios.get("/articles");
        setArticles(articlesResponse.data.articles);

        // ดึงข้อมูลหมวดหมู่
        const categoriesResponse = await axios.get("/categories");
        setCategories(categoriesResponse.data.categories);

        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError("ไม่สามารถโหลดข้อมูลได้ กรุณาลองใหม่อีกครั้ง");
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // กรองตามหมวดหมู่
  const filterByCategory = (article) => {
    if (selectedCategory === "all") {
      return true;
    }
    return article.category_id === parseInt(selectedCategory);
  };

  // กรองตามการค้นหา
  const filterBySearch = (article) => {
    if (!searchQuery) {
      return true;
    }
    const query = searchQuery.toLowerCase();
    return (
      article.title.toLowerCase().includes(query) ||
      article.content.toLowerCase().includes(query) ||
      article.author_name.toLowerCase().includes(query) ||
      article.category_name.toLowerCase().includes(query)
    );
  };

  // เรียงลำดับบทความ
  const sortArticles = (a, b) => {
    if (sortBy === "newest") {
      return new Date(b.created_at) - new Date(a.created_at);
    } else if (sortBy === "oldest") {
      return new Date(a.created_at) - new Date(b.created_at);
    } else if (sortBy === "popular") {
      return b.view_count - a.view_count;
    } else if (sortBy === "rating") {
      return (b.avg_rating || 0) - (a.avg_rating || 0);
    }
    return 0;
  };

  // กรองและเรียงลำดับบทความ
  const filteredArticles = articles
    .filter(filterByCategory)
    .filter(filterBySearch)
    .sort(sortArticles);

  // แสดงสถานะการโหลด
  if (loading) {
    return (
      <div className="container">
        {/* <div className="loading-spinner">กำลังโหลดบทความ...</div> */}
      </div>
    );
  }

  // แสดงข้อผิดพลาด
  if (error) {
    return (
      <div className="container">
        <div className="alert alert-danger">
          <i className="fas fa-exclamation-circle"></i> {error}
        </div>
      </div>
    );
  }

  return (
    <div className="articles-page">
      <div className="container">
        <div className="page-header">
          <h1 className="page-title">
            <i className="fas fa-pen-fancy"></i> บทความและแนวคิด
          </h1>
          <p className="page-description">
            แลกเปลี่ยนแนวคิด มุมมอง
            และประสบการณ์ในการจัดการเรียนการสอนจากครูทั่วประเทศ
          </p>
        </div>

        <div className="articles-toolbar">
          <div className="toolbar-filters">
            <div className="form-group">
              <label>หมวดหมู่:</label>
              <select
                className="form-select"
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
              >
                <option value="all">ทั้งหมด</option>
                {categories.map((category) => (
                  <option key={category.id} value={category.id}>
                    {category.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>เรียงตาม:</label>
              <select
                className="form-select"
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
              >
                <option value="newest">ใหม่ล่าสุด</option>
                <option value="oldest">เก่าที่สุด</option>
                <option value="popular">ยอดนิยม</option>
                <option value="rating">คะแนนสูงสุด</option>
              </select>
            </div>
          </div>

          <div className="toolbar-search">
            <div className="search-input">
              <i className="fas fa-search"></i>
              <input
                type="text"
                placeholder="                  ค้นหาบทความ..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              {searchQuery && (
                <button
                  className="clear-search"
                  onClick={() => setSearchQuery("")}
                >
                  <i className="fas fa-times"></i>
                </button>
              )}
            </div>
          </div>

          <div className="toolbar-actions">
            <Link to="/write-article" className="btn btn-primary">
              <i className="fas fa-pen"></i> เขียนบทความ
            </Link>
          </div>
        </div>

        {filteredArticles.length === 0 ? (
          <div className="no-results">
            <i className="fas fa-search"></i>
            <h3>ไม่พบบทความที่ตรงกับเงื่อนไข</h3>
            <p>ลองเปลี่ยนเงื่อนไขการค้นหาหรือเลือกหมวดหมู่อื่น</p>
          </div>
        ) : (
          <div className="articles-container">
            {filteredArticles.map((article) => (
              <div className="article-card" key={article.id}>
                <div className="article-thumbnail">
                  <Link to={`/articles/${article.id}`}>
                    <img
                      src={
                        article.thumbnail
                          ? `${process.env.REACT_APP_API_URL}/uploads/${article.thumbnail}`
                          : "/assets/default-article.jpg"
                      }
                      alt={article.title}
                    />
                  </Link>
                  <div className="article-category">
                    <i className="fas fa-folder"></i> {article.category_name}
                  </div>
                </div>

                <div className="article-content">
                  <h2 className="article-title">
                    <Link to={`/articles/${article.id}`}>{article.title}</Link>
                  </h2>

                  <div className="article-meta">
                    <div className="article-author">
                      <img
                        src={
                          article.author_image
                            ? `${process.env.REACT_APP_API_URL}/uploads/profiles/${article.author_image}`
                            : `https://ui-avatars.com/api/?name=${article.author_name}&background=random`
                        }
                        alt={article.author_name}
                      />
                      <span>{article.author_name}</span>
                    </div>

                    <div className="article-date">
                      <i className="far fa-calendar-alt"></i>{" "}
                      {new Date(article.created_at).toLocaleDateString("th-TH")}
                    </div>
                  </div>

                  <div className="article-excerpt">
                    {article.content
                      ? article.content.length > 200
                        ? `${article.content.substring(0, 200)}...`
                        : article.content
                      : "ไม่มีเนื้อหา"}
                  </div>

                  <div className="article-footer">
                    <div className="article-stats ">
                      <div className="article-views">
                        <i className="fas fa-eye"></i> {article.view_count}
                      </div>

                      <div className="article-rating">
                        <i className="fas fa-star"></i>
                        {article.avg_rating !== undefined &&
                        article.avg_rating !== null &&
                        !isNaN(Number(article.avg_rating))
                          ? Number(article.avg_rating).toFixed(1)
                          : "0.0"}
                        <span className="rating-count">
                          ({article.rating_count || 0})
                        </span>
                      </div>

                      <div className="article-comments">
                        <i className="fas fa-comments"></i>{" "}
                        {article.comment_count || 0}
                      </div>
                    </div>

                    <Link
                      to={`/articles/${article.id}`}
                      className="btn btn-sm btn-primary"
                    >
                      อ่านต่อ
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ArticlesPage;
